import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    actions: {
      delete: (count: number) =>
        translate({
          id: 'form.drivers.modal.delete.action.delete',
          values: { count },
        }),
      edit: translate({ id: 'global.edit' }),
      changePassword: translate({ id: 'form.drivers.view.actions.changePassword' }),
    },
    labels: {
      email: translate({ id: 'form.drivers.view.labels.email' }),
      name: translate({ id: 'form.drivers.view.labels.name' }),
      driverTracked: translate({ id: 'form.drivers.view.labels.driverTracked' }),
      tracked: (tracked: boolean) =>
        translate({
          id: tracked ? 'form.drivers.view.labels.tracked' : 'form.drivers.view.labels.notTracked',
        }),
      mobileFutureDaysVisibility: translate({
        id: 'form.drivers.view.labels.mobileFutureDaysVisibility',
      }),
      summarizeFutureMobileRoute: translate({
        id: 'form.drivers.view.labels.summarizeFutureMobileRoute',
      }),
      addNewBarcodes: translate({
        id: 'form.drivers.view.labels.addNewBarcodes',
      }),
    },
    titles: {
      driverApp: translate({ id: 'form.drivers.driverApp.title' }),
      routeViewPreferences: translate({ id: 'form.drivers.driverApp.routeViewPreferences' }),
    },
    values: {
      mobileFutureDaysVisibility: (
        mobileFutureDaysVisibility: uui.domain.client.rm.MobileFutureDaysVisibility,
      ) => {
        switch (mobileFutureDaysVisibility) {
          case -1:
            return translate({
              id: 'form.drivers.view.values.mobileFutureDaysVisibility.allDays',
            })
          case 2:
            return translate({
              id: 'form.drivers.view.values.mobileFutureDaysVisibility.todayAndNextTwoDays',
            })
          default:
            return mobileFutureDaysVisibility
        }
      },
      summarizeFutureMobileRoute: (summarizeFutureMobileRoute: boolean) => {
        switch (summarizeFutureMobileRoute) {
          case true:
            return translate({ id: 'form.drivers.view.values.summarizeFutureMobileRoute.summary' })
          case false:
            return translate({
              id: 'form.drivers.view.values.summarizeFutureMobileRoute.fullDetails',
            })
        }
      },
      barcodeAttachmentAllowed: (barcodeAttachmentAllowed: boolean) => {
        switch (barcodeAttachmentAllowed) {
          case true:
            return translate({ id: 'global.enabled' })
          case false:
            return translate({
              id: 'global.disabled',
            })
        }
      },
    },
    telematicsServiceUnavailable: translate({ id: 'global.telematicsServiceUnavailable' }),
  }))

  return api
}
